export function monthDiff(from, to) {
  var months =
    to.getMonth() -
    from.getMonth() +
    12 * (to.getFullYear() - from.getFullYear()) +
    1;

  return months;
}

export function calculateAge(birthdate) {
  const currentDate = new Date();
  let age = currentDate.getFullYear() - birthdate.getFullYear();

  if (
    currentDate.getMonth() < birthdate.getMonth() ||
    (currentDate.getMonth() === birthdate.getMonth() &&
      currentDate.getDate() < birthdate.getDate())
  ) {
    age--;
  }

  return age;
}
